var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicDesigning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 641,
    viewBox: "0 0 641 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 641,
    fill: "url(#paint0_linear_5_133)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 442C105 442 145.896 355.913 208.545 303.739C271.195 251.565 317.312 429.826 412.156 375.913C507 322 457.403 186.348 507 182",
    stroke: "black",
    strokeWidth: 23
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_133",
    x1: 4.13044e-8,
    y1: 319.167,
    x2: 641,
    y2: 321.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9752AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F00AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesigning);
export default __webpack_public_path__ + "static/media/graphic-designing.04118e38d80847d925b3dca0f19d36a4.svg";
export { ForwardRef as ReactComponent };